<template>
  <div class="block">
    <el-cascader
      size="small"
      v-model="selectedOptions"
      :options="options"
      :props="{ value: 'value', label: 'label', expandTrigger: 'hover', checkStrictly: check_strictly }"
      @change="handleChange"
      @clean="handleChange"
      clearable 
      style="width: 250px;"
    >
    </el-cascader>
  </div>
</template>
<script>
import Config from "~/config/params";
export default {
  name: "ClueStatus",
  props: {
    status: {
      type: Number,
      default: 0
    },
    status_child: {
      type: Number,
      default: 0
    },
    check_strictly: {
      type: Boolean,
      default: true
    },
    is_edit: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selectedOptions: [],
      options: Config.leadStatuses(),
    };
  },

  created() {
      if(this.status > 0){
        this.selectedOptions = [this.status];
      }
      if(this.status_child > 0){
        this.selectedOptions.push(this.status_child);
      }
      if(this.is_edit){
        this.options = Config.leadStatuses().filter(item => item.value != 0 && item.value != '')
      }
  },

  mounted() {

  },
  methods: {
    
    handleChange(value) {
      this.selectedOptions = value;
      this.$emit("change", value);
    },

    reset() {
      this.selectedOptions = [];
      this.$emit("change", []);
    }
  },
};
</script>




// WEBPACK FOOTER //
// src/widgets/ClueStatus.vue